import { authenticatedHttpRequest } from '../http';

export function registerDownload(nodeId: string) {
  authenticatedHttpRequest('/graph', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    body: JSON.stringify({
      query: `mutation RegisterTrackingAction_Mutation($input: TrackingRegisterActionMutationInput!) {
          registerTrackingAction(input: $input) {
            success
          }
        }
      `,
      variables: {
        input: {
          action: {
            nodeId,
            action: 'DOWNLOAD',
            referralUrl: window.location.href,
          },
        },
      },
    }),
  });
}
